import WebApp from '@twa-dev/sdk';

export const tg = WebApp;

/**
 * initData для авторизации на бэкенде.
 * Вне Telegram (обычный браузер при отладке) берём подписанную строку из
 * VITE_DEV_INIT_DATA — её генерирует `npm run gen:initdata`. Подпись при этом
 * настоящая, сервер проверяет её как обычно.
 */
export function getInitData(): string {
  if (WebApp.initData) return WebApp.initData;
  return import.meta.env.VITE_DEV_INIT_DATA ?? '';
}

export function isInsideTelegram(): boolean {
  return Boolean(WebApp.initData);
}

/** Параметр из ?startapp=... — определяет, какую подборку открыть. */
export function getStartParam(): string | undefined {
  const fromSdk = WebApp.initDataUnsafe?.start_param;
  if (fromSdk) return fromSdk;
  const search = new URLSearchParams(window.location.search);
  return search.get('tgWebAppStartParam') ?? search.get('startapp') ?? undefined;
}

export function parseCollectionId(startParam: string | undefined): string | undefined {
  if (!startParam) return undefined;
  const match = startParam.match(/^col_([a-z0-9]{6,32})$/);
  return match?.[1];
}

/** Переносит тему Telegram в CSS-переменные. */
export function applyTheme(): void {
  const root = document.documentElement;
  const params = WebApp.themeParams ?? {};
  const map: Record<string, string | undefined> = {
    '--bg': params.bg_color,
    '--secondary-bg': params.secondary_bg_color,
    '--text': params.text_color,
    '--hint': params.hint_color,
    '--link': params.link_color,
    '--button': params.button_color,
    '--button-text': params.button_text_color,
  };
  for (const [name, value] of Object.entries(map)) {
    if (value) root.style.setProperty(name, value);
  }
  root.dataset.scheme = WebApp.colorScheme ?? 'light';
}

export function init(): void {
  try {
    WebApp.ready();
    WebApp.expand();
    WebApp.setHeaderColor?.('secondary_bg_color');
    applyTheme();
    WebApp.onEvent('themeChanged', applyTheme);
  } catch {
    // Вне Telegram часть методов недоступна — это нормально для локальной отладки.
  }
}

export function haptic(style: 'light' | 'medium' | 'rigid' = 'light'): void {
  try {
    WebApp.HapticFeedback.impactOccurred(style);
  } catch {
    /* нет вибромотора — не беда */
  }
}

export function notify(type: 'error' | 'success' | 'warning'): void {
  try {
    WebApp.HapticFeedback.notificationOccurred(type);
  } catch {
    /* игнорируем */
  }
}

/** Открывает внешнюю ссылку магазина. */
export function openShop(url: string): void {
  try {
    WebApp.openLink(url, { try_instant_view: false });
  } catch {
    window.open(url, '_blank', 'noopener');
  }
}

export function setBackButton(visible: boolean, handler?: () => void): () => void {
  try {
    if (visible && handler) {
      WebApp.BackButton.onClick(handler);
      WebApp.BackButton.show();
      return () => {
        WebApp.BackButton.offClick(handler);
        WebApp.BackButton.hide();
      };
    }
    WebApp.BackButton.hide();
  } catch {
    /* вне Telegram кнопки нет */
  }
  return () => {};
}
